<template>
  <v-content class="bg-content-box">
  <v-container fluid>
    <!-- Mode toolbar -->

    <v-row>
      <v-col cols="12" md="12">
        <v-card class="glass-card pa-4 mb-4" outlined>
          <h3 class="mb-2">Shadowbox Creator</h3>
          <!-- <p class="grey--text">Create beautiful 3D shadowboxes with custom backgrounds, layers, and plaques.</p> -->


        <v-btn-toggle v-model="mode" mandatory>
          <v-btn value="flat"><v-icon left>mdi-image</v-icon>2D Flat</v-btn>
          <v-btn value="3d"><v-icon left>mdi-cube-outline</v-icon>3D Render</v-btn>
        </v-btn-toggle>
                </v-card>
      </v-col>
    </v-row>
    <!-- Project Gallery Section -->
<v-row>
  <v-col cols="12">
    <v-card class="glass-card2 pa-4 mb-4" outlined>
      <h3 class="mb-2">Saved Projects Gallery</h3>
      <v-row>
        <v-col
          v-for="(project, name) in savedProjects"
          :key="name"
          cols="12"
          sm="6"
          md="3"
        >
          <v-card outlined class="glass-card project-gallery-card">
            <div style="text-align:center;">
              <img
                :src="getGalleryPreview(project)"
                style="max-width:100%;max-height:120px;border-radius:10px;background:#26293d;"
                :alt="name"
              />
            </div>
            <div class="mt-2" style="font-weight:600;word-break:break-word;">
              {{ name }}
            </div>
            <v-btn small color="primary" class="mt-1 mr-1" @click="galleryLoadProject(name)">Load</v-btn>
            <v-btn small color="error" class="mt-1 mr-1" @click="galleryDeleteProject(name)">Delete</v-btn>
            <v-btn small color="info" class="mt-1" @click="galleryExportProject3D(name)">Export 3D</v-btn>
<v-btn small color="success" class="mt-1" @click="openShareDialog(name)">
  Share 3D
</v-btn>


          </v-card>
        </v-col>
        <v-col v-if="!Object.keys(savedProjects).length" cols="12">
          <span class="grey--text">No projects saved yet.</span>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</v-row>
    <!-- Wall controls + project controls -->
    <v-row>
      <v-col cols="12" md="8">
        <v-card class="glass-card pa-4 mb-4" outlined>
          <v-row>
            <v-col cols="12" md="3">
              <v-file-input
                label="Wall Image"
                accept="image/*"
                dark
                prepend-icon="mdi-image-plus"
                @change="onWallImageUpload"
                hide-details dense />
            </v-col>
            <v-col cols="12" md="3">
              <v-color-picker
                v-model="wallColor"
                flat hide-canvas hide-inputs hide-mode-switch
                swatches-max-height="150"
                style="height:56px"
              />
              <small>Wall Color</small>
            </v-col>
            <v-col cols="12" md="3" class="d-flex align-center">
              <v-btn @click="resetWall" color="secondary" outlined small icon><v-icon>mdi-restore</v-icon></v-btn>
              <span class="ml-2">Reset Wall</span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="glass-card pa-4 mb-4" outlined>
          <v-text-field dark v-model="projectName" label="Project Name" maxlength="40" class="mb-2"/>
          <v-btn color="primary" class="mr-2 mb-2" @click="saveProject">Save</v-btn>
          <v-select
            dark
            v-model="selectedProject"
            :items="projectNames"
            label="Projects"
            dense
            class="mb-2"
          />


          <v-btn color="primary" class="mr-2 mb-2" @click="loadProject">Load</v-btn>
          <v-btn color="error" class="mr-2 mb-2" @click="deleteProject">Delete</v-btn>
          <v-btn color="info" class="mb-2" @click="renameProject">Rename</v-btn>
        </v-card>
      </v-col>
    </v-row>
<v-dialog v-model="shareDialog" max-width="480">
  <v-card>
    <v-progress-linear
  v-if="isSharing"
  :value="shareProgress"
  height="7"
  color="primary"
  class="mb-4"
  striped
  indeterminate
></v-progress-linear>

    <v-card-title>
      <span class="headline">Share 3D Project by Email</span>
    </v-card-title>
    <v-card-text>
      <v-text-field
  label="Recipient Email"
  v-model="shareEmail"
  type="email"
  :disabled="isSharing"
  required
  :rules="[v => !!v || 'Email is required']"
/>
<v-text-field
  label="Share Link"
  v-model="shareLink"
  readonly
  append-icon="mdi-content-copy"
  @click:append="copyShareLink"
  :disabled="isSharing"
/>

      <small>
        The recipient can open this link to view and interact with the 3D scene.
      </small>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="grey darken-1" text @click="shareDialog = false">Cancel</v-btn>
      <v-btn color="primary" @click="sendShareEmail" :disabled="isSharing">Send Email</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- Shadowbox controls -->
    <v-row>
      <v-col cols="12">
        <v-card class="glass-card pa-4 mb-4" outlined>
          <v-row>
            <v-col cols="12" sm="3">
              <v-file-input label="Border" accept="image/*" prepend-icon="mdi-palette" @change="onBgUpload" hide-details dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-file-input label="Add Layer" accept="image/*" prepend-icon="mdi-layers-plus" @change="onLayerUpload" hide-details dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-file-input label="Plaque" accept="image/*" prepend-icon="mdi-label" @change="onPlaqueUpload" hide-details dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="plaqueText" label="Plaque Text (optional)" maxlength="40" dense hide-details />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Size controls -->
    <v-row>
      <v-col cols="12">
        <v-card class="glass-card pa-4 mb-4" outlined>
          <v-row>
            <v-col cols="4" sm="2">
              <v-text-field
                v-model.number="boxWidth"
                label="Width (mm)"
                type="number"
                min="100" max="1200"
                @input="syncAspect('width')"
                dense
              />
            </v-col>
            <v-col cols="4" sm="2">
              <v-text-field
                v-model.number="boxHeight"
                label="Height (mm)"
                type="number"
                min="100" max="900"
                @input="syncAspect('height')"
                dense
              />
            </v-col>
            <v-col cols="4" sm="2">
              <v-text-field
                v-model.number="boxDepth"
                label="Depth (mm)"
                type="number"
                min="20" max="400"
                dense
              />
            </v-col>
            <v-col cols="12" sm="3" class="d-flex align-center">
              <v-checkbox
                v-model="lockAspect"
                label="Lock aspect"
                hide-details
                class="mr-4"
                dense
              />
              <v-btn color="primary" @click="applySize">Apply</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Layers + Render -->
    <v-row>
      <v-col cols="12" md="3">
        <v-card class="glass-card pa-4 mb-4" outlined>
          <h3 class="mb-2">Shadowbox Layers</h3>
          <div><strong>Border:</strong>
            <div v-if="background">
              <img :src="background.src" width="52" height="40" style="border-radius:4px;">
            </div>
            <span v-else class="grey--text lighten-1">No background</span>
          </div>
          <v-divider class="my-2"/>
          <draggable
            v-model="layers"
            tag="div"
            :options="{animation:150}"
            class="layer-list"
          >
            <div
              v-for="(layer, i) in layers"
              :key="layer.src"
              class="d-flex align-center mb-2"
            >
              <v-avatar size="40" class="mr-2">
                <img :src="layer.src" />
              </v-avatar>
              <span>Layer {{ i + 1 }}</span>
              <v-spacer/>
              <v-btn x-small icon @click="moveLayer(i, -1)" :disabled="i===0"><v-icon>mdi-arrow-up</v-icon></v-btn>
              <v-btn x-small icon @click="moveLayer(i, 1)" :disabled="i===layers.length-1"><v-icon>mdi-arrow-down</v-icon></v-btn>
              <v-btn x-small icon color="error" @click="deleteLayer(i)"><v-icon>mdi-delete</v-icon></v-btn>
            </div>
          </draggable>
          <v-divider class="my-2"/>
          <div>
            <strong>Plaque:</strong>
            <div v-if="plaque">
              <img :src="plaque.src" width="52" height="40" style="border-radius:4px;">
            </div>
            <span v-else class="grey--text lighten-1">No plaque</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <v-card class="glass-card pa-4 mb-4" outlined style="min-height:500px;">
          <div v-show="mode === 'flat'" style="position:relative;">
            <canvas ref="canvasFlat" width="600" height="450"
              style="border-radius:13px;border:2px solid #404360;box-shadow:0 2px 28px #0007;display:block;margin:auto;"/>
            <div class="plaque-preview" v-show="plaqueText">{{ plaqueText }}</div>
          </div>
          <div v-show="mode === '3d'" ref="renderer3d" style="width:100%;min-height:640px;"></div>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
  </v-content>
</template>

<script>
import draggable from "vuedraggable";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default {
  name: "Shadowbox",
  components: { draggable },
  data() {
    return {
      mode: "flat",
      wallColor: "#d4d6e0",
      wallImage: null,
      background: null,
      layers: [],
      plaque: null,
      plaqueText: "",
      boxWidth: 900,
      boxHeight: 700,
      boxDepth: 20,
      lockAspect: true,
      aspect: 900 / 700,
      projectName: "",
      selectedProject: "",
      savedProjects: {},
      projectThumbnails: {},
      shareDialog: false,
      shareLink: "",
      shareProjectName: "",
      shareEmail: "",
      isSharing: false,
      shareProgress: 0,
      shareTimeout: null,
    };
  },
  computed: {
    projectNames() {
      return Object.keys(this.savedProjects);
    }
  },
  watch: {
    plaqueText: "drawFlat",
    mode(val) {
      this.$nextTick(() => {
        if (val === "3d") this.render3DShadowbox();
        else this.drawFlat();
      });
    }
  },
  mounted() {
    this.getSavedProjects();
    this.$nextTick(this.drawFlat);
      let encoded = window.location.hash.replace(/^#/, "");
  if (!encoded) {
    // fallback to ?data= param if you prefer
    const params = new URLSearchParams(window.location.search);
    encoded = params.get('data');
  }
  if (encoded) {
    try {
      const data = JSON.parse(atob(decodeURIComponent(encoded)));
      this.importCurrentData(data); // load as usual
      this.mode = "3d"; // auto-show 3D view
    } catch (err) {
      alert("Invalid or corrupt project data.");
    }
  }
  },
  methods: {
downscaleImage(src, maxWidth, maxHeight) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = function () {
      let ratio = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
      let w = Math.round(img.width * ratio);
      let h = Math.round(img.height * ratio);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      canvas.getContext("2d").drawImage(img, 0, 0, w, h);

      // Detect image type
      let mime = "image/jpeg"; // default
      let quality = 0.74;
      if (src.startsWith("data:image/png")) {
        mime = "image/png";
        // PNG is lossless, but may be larger.
      }
      // For JPEGs, use quality. For PNG, ignore quality param.
      resolve(canvas.toDataURL(mime, quality));
    };
    img.src = src;
  });
},

async createShareExport(project) {
  const maxW = 400, maxH = 300;
  async function slimImg(obj) {
    if (!obj || !obj.src) return null;
    return { src: await this.downscaleImage(obj.src, maxW, maxH) };
  }
  return {
    boxWidth: project.boxWidth,
    boxHeight: project.boxHeight,
    boxDepth: project.boxDepth,
    plaqueText: project.plaqueText,
    wallColor: project.wallColor,
    background: await slimImg.call(this, project.background),
    plaque: await slimImg.call(this, project.plaque),
    wallImage: await slimImg.call(this, project.wallImage),
    layers: await Promise.all((project.layers || []).map(l => slimImg.call(this, l))),
  };
},

async openShareDialog(name) {
  this.isSharing = true;
  this.shareProgress = 0;
  this.shareDialog = true;
  this.shareLink = "";

  this.shareTimeout = setInterval(() => {
    if (this.shareProgress < 90) this.shareProgress += 10;
  }, 80);

  setTimeout(async () => {
    const project = this.savedProjects[name];
    if (!project) {
      this.isSharing = false;
      clearInterval(this.shareTimeout);
      return;
    }
    const slim = await this.createShareExport(project);
    const encoded = encodeURIComponent(btoa(JSON.stringify(slim)));
    this.shareLink = `${window.location.origin}/viewer#${encoded}`;
    this.shareProjectName = name;
    this.shareEmail = "";
    this.isSharing = false;
    this.shareProgress = 100;
    clearInterval(this.shareTimeout);
  }, 200);
},



  copyShareLink() {
    navigator.clipboard.writeText(this.shareLink);
    this.$emit('showSnackbar', 'Link copied!');
  },
sendShareEmail() {
  if (!this.shareEmail || !this.shareProjectName || !this.shareLink) {
    this.$emit('showSnackbar', 'Missing recipient, project name, or link.');
    return;
  }

  const subject = `Check out this 3D Shadowbox project: "${this.shareProjectName}"`;
  const body = `
Hi,

Open this link to view and interact with the 3D scene:

${this.shareLink}

Best regards,
${this.fromName || 'Your Name'}
`.trim();

  const mailtoLink = `mailto:${encodeURIComponent(this.shareEmail)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  window.open(mailtoLink, '_blank'); // This will open Outlook Desktop if it is the default!

  this.shareDialog = false;
},


    resetWall() {
      this.wallColor = "#d4d6e0";
      this.wallImage = null;
      if (this.mode === "3d") this.render3DShadowbox();
    },
    // handleImageUpload(files, cb) {
    //   const file = Array.isArray(files) ? files[0] : files;
    //   if (!file) return;
    //   const url = URL.createObjectURL(file);
    //   const img = new window.Image();
    //   img.onload = () => cb({ img, src: url });
    //   img.src = url;
    // },
    moveLayer(i, dir) {
      const j = i + dir;
      if (j < 0 || j >= this.layers.length) return;
      const temp = this.layers[i];
      this.$set(this.layers, i, this.layers[j]);
      this.$set(this.layers, j, temp);
      this.drawFlat();
    },
    deleteLayer(i) {
      this.layers.splice(i, 1);
      this.drawFlat();
    },
drawFlat() {
      const canvas = this.$refs.canvasFlat;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      canvas.width = 600;
      canvas.height = 450;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (this.wallImage) ctx.drawImage(this.wallImage.img, 0, 0, canvas.width, canvas.height);
      if (this.background) ctx.drawImage(this.background.img, 0, 0, canvas.width, canvas.height);
      this.layers.forEach(layer => ctx.drawImage(layer.img, 0, 0, canvas.width, canvas.height));
      if (this.plaque) ctx.drawImage(this.plaque.img, canvas.width / 2 - 80, canvas.height - 66, 160, 38);

      if (this.plaqueText) {
        ctx.save();
        ctx.font = "bold 19px Segoe UI,Arial";
        ctx.textAlign = "center";
        ctx.fillStyle = "#c4ae76";
        ctx.strokeStyle = "#312916";
        ctx.lineWidth = 2.5;
        ctx.strokeText(this.plaqueText, canvas.width / 2, canvas.height - 25);
        ctx.fillText(this.plaqueText, canvas.width / 2, canvas.height - 25);
        ctx.restore();
      }

      ctx.save();
      ctx.strokeStyle = "rgba(135,220,255,0.6)";
      ctx.lineWidth = 8;
      ctx.strokeRect(6, 6, canvas.width - 12, canvas.height - 12);
      ctx.restore();
    },

    syncAspect(type) {
      if (!this.lockAspect) {
        this.aspect = this.boxWidth / this.boxHeight;
        return;
      }
      if (type === "width") {
        this.boxHeight = Math.round(this.boxWidth / this.aspect);
      } else {
        this.boxWidth = Math.round(this.boxHeight * this.aspect);
      }
    },

    applySize() {
      this.drawFlat();
      if (this.mode === "3d") this.render3DShadowbox();
    },
handleImageUpload(files, cb) {
  const file = Array.isArray(files) ? files[0] : files;
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    const img = new window.Image();
    img.onload = () => cb({ img, src: e.target.result });
    img.src = e.target.result;
  };
  reader.readAsDataURL(file); // this makes src always a dataURL
},

onWallImageUpload(files) {
  this.handleImageUpload(files, val => {
    this.wallImage = val;
    this.wallColor = "#d4d6e0";
    if (this.mode === "3d") this.render3DShadowbox();
  });
},
onBgUpload(files) {
  this.handleImageUpload(files, val => {
    this.background = val;
    this.drawFlat();
  });
},
onLayerUpload(files) {
  this.handleImageUpload(files, val => {
    this.layers.push(val);
    this.drawFlat();
  });
},
onPlaqueUpload(files) {
  this.handleImageUpload(files, val => {
    this.plaque = val;
    this.drawFlat();
  });
},
exportCurrentData() {
  function imgToData(obj) {
    if (!obj) return null;
    return { src: obj.src };
  }
  return {
    boxWidth: this.boxWidth,
    boxHeight: this.boxHeight,
    boxDepth: this.boxDepth,
    plaqueText: this.plaqueText,
    background: imgToData(this.background),
    plaque: imgToData(this.plaque),
    layers: this.layers.map(imgToData),
    wallColor: this.wallColor,
    wallImage: imgToData(this.wallImage),
  };
},

importCurrentData(data) {
  if (!data) return;
  this.boxWidth = data.boxWidth || 600;
  this.boxHeight = data.boxHeight || 450;
  this.boxDepth = data.boxDepth || 40;
  this.plaqueText = data.plaqueText || "";
  this.wallColor = data.wallColor || "#d4d6e0";
  function dataToImg(obj) {
    if (!obj) return null;
    const img = new Image();
    img.src = obj.src;
    return { img, src: obj.src };
  }
  this.background = dataToImg(data.background);
  this.plaque = dataToImg(data.plaque);
  this.wallImage = dataToImg(data.wallImage);
  this.layers = (data.layers || []).map(dataToImg);
  this.$nextTick(() => {
    this.drawFlat();
    if (this.mode === "3d") this.render3DShadowbox();
  });
},

saveProject() {
  if (!this.projectName.trim()) {
    alert("Name required");
    return;
  }

  // Always work from a copy, not directly from this.savedProjects!
  let all = JSON.parse(localStorage.getItem("shadowboxProjects") || "{}");

  // Debug: log what is currently stored
  console.log("Before save, all projects in localStorage:", all);

  // Save latest export (should include all data, images as base64 src)
  const exportedData = this.exportCurrentData();
  all[this.projectName] = exportedData;

  // Debug: log the data structure being saved
  console.log(`Saving project "${this.projectName}":`, exportedData);

  // Write to localStorage
  localStorage.setItem("shadowboxProjects", JSON.stringify(all));

  // Debug: confirm write and check full structure
  const updatedAll = JSON.parse(localStorage.getItem("shadowboxProjects") || "{}");
  console.log("After save, all projects in localStorage:", updatedAll);

  // Refresh the live gallery and selector (ALWAYS use fresh object for reactivity!)
  this.getSavedProjects();

  // Update v-select value to this project
  this.selectedProject = this.projectName;

  alert("Project saved!");
},


  loadProject() {
    if (!this.selectedProject) return;
    const all = JSON.parse(localStorage.getItem("shadowboxProjects") || "{}");
    this.importCurrentData(all[this.selectedProject]);
    this.projectName = this.selectedProject;
    alert("Loaded!");
  },
  deleteProject() {
    if (!this.selectedProject) return;
    const all = JSON.parse(localStorage.getItem("shadowboxProjects") || "{}");
    if (confirm("Delete this shadowbox?")) {
      delete all[this.selectedProject];
      localStorage.setItem("shadowboxProjects", JSON.stringify(all));
      this.getSavedProjects();
      this.selectedProject = "";
      this.projectName = "";
    }
  },
    // ---- Gallery Thumbnail Preview ----
  getGalleryPreview(project) {
    // Return background, wall, plaque, or a placeholder
    if (project.background && project.background.src) return project.background.src;
    if (project.wallImage && project.wallImage.src) return project.wallImage.src;
    if (project.plaque && project.plaque.src) return project.plaque.src;
    // Otherwise return a placeholder image (you can swap this for your logo)
    return "https://dummyimage.com/300x150/20253a/fff&text=No+Preview";
  },
  galleryLoadProject(name) {
    this.selectedProject = name;
    this.loadProject();
    // Optionally, scroll up to the editor
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
  },
  galleryDeleteProject(name) {
    if (!name) return;
    if (confirm(`Delete "${name}"?`)) {
      const all = JSON.parse(localStorage.getItem("shadowboxProjects") || "{}");
      delete all[name];
      localStorage.setItem("shadowboxProjects", JSON.stringify(all));
      this.getSavedProjects();
    }
  },
  galleryExportProject3D(name) {
    // Load then export, unless already loaded
    if (this.selectedProject !== name) {
      this.selectedProject = name;
      this.importCurrentData(this.savedProjects[name]);
      setTimeout(() => this.exportCurrent3DAsImage(name), 500);
    } else {
      this.exportCurrent3DAsImage(name);
    }
  },
  exportCurrent3DAsImage(filename = "Shadowbox3D") {
    // Try to find the THREE renderer
    const container = this.$refs.renderer3d;
    if (!container) {
      alert("3D view not found. Switch to 3D mode first.");
      return;
    }
    // Find the canvas inside the 3D container
    const canvas = container.querySelector("canvas");
    if (!canvas) {
      alert("No 3D render found. Switch to 3D mode first.");
      return;
    }
    // Export as PNG (change to image/jpeg if you want JPG)
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  renameProject() {
    if (!this.selectedProject) return;
    const newKey = prompt("Rename project to:", this.selectedProject);
    if (!newKey) return;
    const all = JSON.parse(localStorage.getItem("shadowboxProjects") || "{}");
    all[newKey] = all[this.selectedProject];
    delete all[this.selectedProject];
    localStorage.setItem("shadowboxProjects", JSON.stringify(all));
    this.getSavedProjects();
    this.selectedProject = newKey;
    this.projectName = newKey;
  },
getSavedProjects() {
  // This makes Vue re-render gallery when changed
  this.savedProjects = { ...JSON.parse(localStorage.getItem("shadowboxProjects") || "{}") };
},

    // 3D RENDER BLOCK -- mostly unchanged except all state is from this.*
render3DShadowbox() {
  const container = this.$refs.renderer3d;
  if (!container) return;
  container.innerHTML = '';

  // Enforce minimum shadowbox size
  this.boxWidth = Math.max(this.boxWidth, 720);
  this.boxHeight = Math.max(this.boxHeight, 619);

  const canvasPixelWidth = 1850;
  const targetAspect = this.boxWidth / this.boxHeight;
  const width = canvasPixelWidth;
  const height = Math.round(width / targetAspect);

  const scene = new THREE.Scene();
  const cameraDistance = Math.max(this.boxWidth, this.boxHeight) * 2;
  const camera = new THREE.PerspectiveCamera(35, width / height, 1, 3000);
  camera.position.set(0, 0, cameraDistance);

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
  renderer.setClearColor(0x161a23, 1);
  renderer.setSize(width, height, false);
  container.appendChild(renderer.domElement);


  // WALL
 const wallMargin = 600;
  const wallWidth = this.boxWidth + wallMargin * 2;
  const wallHeight = this.boxHeight + wallMargin * 2;
  const wallZ = -((this.boxDepth / 2) + 2);
  const wallGeometry = new THREE.PlaneGeometry(wallWidth, wallHeight);

  let wallMaterial;
  if (this.wallImage) {
    const tex = new THREE.TextureLoader().load(this.wallImage.src);
    wallMaterial = new THREE.MeshPhongMaterial({ map: tex, shininess: 18, side: THREE.DoubleSide });
  } else {
    const wallCanvas = document.createElement('canvas');
    wallCanvas.width = 64;
    wallCanvas.height = 64;
    const wallCtx = wallCanvas.getContext('2d');
    wallCtx.fillStyle = this.wallColor;
    wallCtx.fillRect(0, 0, 64, 64);
    for (let i = 0; i < 250; i++) {
      wallCtx.fillStyle = 'rgba(155,156,178,0.09)';
      wallCtx.beginPath();
      wallCtx.arc(Math.random() * 64, Math.random() * 64, Math.random() * 12, 0, 7);
      wallCtx.fill();
    }
    const wallTex = new THREE.CanvasTexture(wallCanvas);
    wallMaterial = new THREE.MeshPhongMaterial({ map: wallTex, shininess: 18, side: THREE.DoubleSide });
  }

  const wall = new THREE.Mesh(wallGeometry, wallMaterial);
  wall.position.set(0, 0, wallZ);
  scene.add(wall);

  // WALL SHADOW
  const shadowGeo = new THREE.PlaneGeometry(this.boxWidth * 1.08, this.boxHeight * 0.15);
  const shadowMat = new THREE.MeshBasicMaterial({
    map: this.generateShadowTexture(this.boxWidth * 1.04, this.boxHeight * 0.13),
    transparent: true,
    opacity: 0.49,
    side: THREE.DoubleSide
  });
  const shadowMesh = new THREE.Mesh(shadowGeo, shadowMat);
  shadowMesh.position.set(0, this.boxHeight / 2 - this.boxHeight * 0.08, wallZ + 1.5);
  shadowMesh.rotation.x = -Math.PI / 2.1;
  scene.add(shadowMesh);

  // LIGHTING
  const spot = new THREE.SpotLight(0xffffff, 1.13, 1800, Math.PI / 2.1, 0.48, 1.15);
  spot.position.set(0, 540, 1100);
  scene.add(spot);

  const rimLight = new THREE.PointLight(0xbbe6fc, 0.34, 900);
  rimLight.position.set(-320, 380, 400);
  scene.add(rimLight);

  const fill = new THREE.DirectionalLight(0xd4eaff, 0.22);
  fill.position.set(-140, -220, 260);
  scene.add(fill);

  const amb = new THREE.AmbientLight(0x7b88a5, 0.19);
  scene.add(amb);

  // FRAME
  const frameGeo = new THREE.BoxGeometry(this.boxWidth + 100, this.boxHeight + 120, this.boxDepth + 100);
  const frameMat = new THREE.MeshPhysicalMaterial({
    color: 0xbbeaff, metalness: 0.26, roughness: 0.10,
    thickness: 14.0, transmission: 0.99, transparent: true, opacity: 0.53,
    ior: 1.52, reflectivity: 0.92, clearcoat: 1.0, clearcoatRoughness: 0.03,
    side: THREE.BackSide, attenuationDistance: 190, attenuationColor: 0x98eaff
  });
  const frame = new THREE.Mesh(frameGeo, frameMat);
  scene.add(frame);

  // GLASS
  const glassGeo = new THREE.PlaneGeometry(this.boxWidth, this.boxHeight);
  const glassMat = new THREE.MeshPhysicalMaterial({
    color: 0xffffff, metalness: 0.6, roughness: 0.08,
    transmission: 1.0, opacity: 0.53, ior: 1.52, thickness: 3,
    transparent: true, reflectivity: 0.98, clearcoat: 1.0, clearcoatRoughness: 0.02,
    side: THREE.FrontSide
  });
  const glass = new THREE.Mesh(glassGeo, glassMat);
  glass.position.z = this.boxDepth / 2 + 2;
  scene.add(glass);

  // REFLECTION
  const reflectGeo = new THREE.PlaneGeometry(this.boxWidth, this.boxHeight);
  const reflectMat = new THREE.MeshBasicMaterial({
    map: this.generateReflectionTexture(this.boxWidth, this.boxHeight),
    transparent: true,
    opacity: 0.5,
    side: THREE.FrontSide,
    depthWrite: false
  });
  const reflect = new THREE.Mesh(reflectGeo, reflectMat);
  reflect.position.z = this.boxDepth / 2 + 2.4;
  scene.add(reflect);

  // BACKGROUND + LAYERS + PLAQUE
  const zBack = -this.boxDepth / 2 + 24;
  const LAYER_GAP = 20;

  if (this.background) {
    const tex = new THREE.TextureLoader().load(this.background.src);
    const mat = new THREE.MeshBasicMaterial({ map: tex });
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(this.boxWidth, this.boxHeight), mat);
    mesh.position.z = zBack;
    scene.add(mesh);
  }

  this.layers.forEach((layer, idx) => {
    const tex = new THREE.TextureLoader().load(layer.src);
    const mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true });
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(this.boxWidth, this.boxHeight), mat);
    mesh.position.z = zBack + (idx + 1) * LAYER_GAP;
    scene.add(mesh);
  });

  const plaqueZ = zBack + (this.layers.length + 2) * LAYER_GAP;
  if (this.plaque) {
    const tex = new THREE.TextureLoader().load(this.plaque.src);
    const mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true });
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(130, 35), mat);
    mesh.position.set(0, this.boxHeight / 2 - 36, plaqueZ);
    scene.add(mesh);
  }

  if (this.plaqueText) {
    const cv = document.createElement('canvas');
    cv.width = 280;
    cv.height = 54;
    const c = cv.getContext('2d');
    c.fillStyle = '#e7d194';
    c.strokeStyle = '#645622';
    c.lineWidth = 4;
    c.fillRect(0, 0, cv.width, cv.height);
    c.font = 'bold 26px Segoe UI,Arial';
    c.textAlign = 'center';
    c.fillStyle = '#37312e';
    c.fillText(this.plaqueText, cv.width / 2, cv.height / 2 + 10);
    const tex = new THREE.CanvasTexture(cv);
    const mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true });
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(150, 40), mat);
    mesh.position.set(0, this.boxHeight / 2 - 36, plaqueZ + 3);
    scene.add(mesh);
  }

  // ORBIT CONTROLS
  const controls = new OrbitControls(camera, renderer.domElement);

  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.minDistance = Math.max(this.boxWidth, this.boxHeight) * 1.2;
  controls.maxDistance = Math.max(this.boxWidth, this.boxHeight) * 6;
  controls.zoomSpeed = 1.0;
  controls.rotateSpeed = 0.8;
  controls.panSpeed = 0.5;

  const animate = () => {
    controls.update();
    renderer.render(scene, camera);
    requestAnimationFrame(animate);
  };
  animate();
},


      // --- 3D export to PNG/JPG ---
    export3DImage(type = 'png') {
      if (this.mode !== '3d') {
        alert("Switch to 3D mode to export image!");
        return;
      }
      this.$nextTick(() => {
        const container = this.$refs.renderer3d;
        if (!container) return;
        const canvas = container.querySelector('canvas');
        if (!canvas) {
          alert("No 3D canvas found!");
          return;
        }
        const mimeType = type === 'jpg' ? 'image/jpeg' : 'image/png';
        const dataUrl = canvas.toDataURL(mimeType);
        // Download the image
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = `shadowbox_3d.${type}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    generateReflectionTexture(w, h) {
      let c = document.createElement('canvas');
      c.width = w; c.height = h;
      let ctx = c.getContext('2d');
      let grad = ctx.createLinearGradient(0, 0, w, h);
      grad.addColorStop(0.01, 'rgba(255,255,255,0.48)');
      grad.addColorStop(0.08, 'rgba(200,240,255,0.10)');
      grad.addColorStop(0.22, 'rgba(0,0,0,0)');
      grad.addColorStop(0.55, 'rgba(255,255,255,0.08)');
      grad.addColorStop(0.8, 'rgba(255,255,255,0.08)');
      grad.addColorStop(1, 'rgba(200,220,255,0)');
      ctx.fillStyle = grad;
      ctx.fillRect(0,0,w,h);
      ctx.beginPath();
      ctx.moveTo(0,h*0.22); ctx.lineTo(w*0.6,0);
      ctx.lineWidth = 15;
      ctx.strokeStyle = 'rgba(255,255,255,0.11)';
      ctx.stroke();
      let tex = new THREE.Texture(c);
      tex.needsUpdate = true;
      return tex;
    },
    generateShadowTexture(w, h) {
      let c = document.createElement('canvas');
      c.width = w; c.height = h;
      let ctx = c.getContext('2d');
      let grad = ctx.createRadialGradient(w/2, h*0.45, h*0.13, w/2, h*0.45, w*0.6);
      grad.addColorStop(0, 'rgba(0,0,0,0.37)');
      grad.addColorStop(0.85, 'rgba(0,0,0,0.07)');
      grad.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = grad;
      ctx.fillRect(0,0,w,h);
      let tex = new THREE.Texture(c);
      tex.needsUpdate = true;
      return tex;
    }
  }
};
</script>

<style scoped>
body {
  font-family: 'Segoe UI', Arial, sans-serif;
  background: #161a23;
  color: #f6f6f9;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}
.dashboard-page {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;
  max-width: 1700px;
  margin: 0 auto;
  padding: 40px 40px 40px 40px;
}
.glass-card {
  background: rgba(36, 39, 58, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: 0 1.5px 10px #0002;
  color: #ffffff;
  text-align: center;
  align-content: center;
}
.glass-card2 {
  background: rgba(36, 39, 58, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: 0 1.5px 10px #0002;
  color: #ffffff;
  text-align: center;
  align-content: center;
}
.bg-content-box {
  background: #9a9b9f;
  padding: 20px;
}
.dashboard-toolbar.toolbar-mid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 22px;
  background: #242745;
  border-radius: 17px;
  box-shadow: 0 2px 22px #0003;
  padding: 22px 30px;
  margin: 24px 0 18px 0;
  width: 100%;
}

.toolbar-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px 12px;
  min-width: 0;
}

.shadowbox-group input[type="text"] {
  min-width: 160px;
  max-width: 260px;
  padding: 7px 13px;
  border-radius: 8px;
  border: 1px solid #43456a;
  background: #20243a;
  color: #fff;
  font-size: 15px;
  margin-left: 5px;
}

@media (max-width: 900px) {
  .dashboard-toolbar.toolbar-mid {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    padding: 12px 3vw;
  }
  .toolbar-group {
    flex-direction: column;
    gap: 9px 0;
    width: 100%;
    margin-bottom: 0;
  }
  .shadowbox-group input[type="text"] {
    min-width: 0;
    width: 100%;
    margin-left: 0;
    margin-top: 7px;
  }
}

.mode-group .btn { min-width: 76px; }
.upload-btn,
.wall-color-group {
  background: #2b2f46;
  padding: 7px 13px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #454564;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: background 0.14s;
}
.upload-btn:hover,
.wall-color-group:hover { background: #383c59; }
.wall-color-group {
  border: 1.5px solid #515182;
  font-weight: 600;
  color: #ffe49b;
}
.wall-color-group input[type="color"] {
  width: 32px;
  height: 32px;
  border-radius: 7px;
  border: none;
  background: #fff;
  cursor: pointer;
  margin-left: 4px;
}
.wall-controls-reset {
  background: #2b2f46;
  color: #fff9b0;
  font-weight: 600;
  border-radius: 7px;
  border: 1px solid #454564;
  padding: 7px 13px;
  cursor: pointer;
  font-size: 15px;
  transition: background 0.16s;
  margin-left: 2px;
}
.wall-controls-reset:hover { background: #415589; color: #fff; }
.btn {
  background: #30415d;
  border: none;
  color: #eaf1ff;
  padding: 8px 18px;
  border-radius: 7px;
  font-size: 25px;
  cursor: pointer;
  font-weight: 600;
  transition: background .18s;
  margin-right: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.btn.active,
.btn:hover { background: #415589; color: #fff; }
#plaqueTextInput {
  min-width: 140px;
  padding: 7px 13px;
  border-radius: 8px;
  border: 1px solid #43456a;
  background: #20243a;
  color: #fff;
  font-size: 15px;
}
.toolbar-bottom {
  display: grid;
  grid-template-columns: 1.5fr 2fr;
  gap: 38px;
  align-items: center;
  background: #23263a;
  border-radius: 15px;
  box-shadow: 0 1.5px 10px #0002;
  padding: 19px 24px 13px 24px;
  margin-bottom: 4px;
  width: 100%;
}
#sizeForm {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(138px, 1fr));
  gap: 10px 18px;
  align-items: center;
  background: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
}
#sizeForm label {
  color: #ffe49b;
  font-weight: 500;
  font-size: 15px;
}
#sizeForm input[type="number"] {
  width: 80px;
  padding: 5px 9px;
  border-radius: 6px;
  border: 1px solid #4c4f70;
  background: #181c32;
  color: #fff;
  font-size: 15px;
}
#sizeForm button.btn {
  margin-left: 0;
}
.project-gallery-card {
  min-height: 230px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background: #20253a;
  border-radius: 15px;
  box-shadow: 0 2px 12px #0002;
  padding: 14px 8px 8px 8px;
  transition: box-shadow .15s;
}
.project-gallery-card:hover {
  box-shadow: 0 5px 24px #00eaff50;
}

.project-group {
  display: grid;
  grid-template-columns: 2fr repeat(5, auto);
  gap: 10px;
  align-items: center;
  min-width: 0;
}
.project-group input[type="text"] {
  padding: 7px 13px;
  border-radius: 8px;
  border: 1px solid #52548b;
  background: #23243d;
  color: #fff9b0;
  font-size: 15px;
  min-width: 145px;
}
.project-group select {
  background: #23243d;
  color: #fff9b0;
  border-radius: 8px;
  border: 1px solid #52548b;
  padding: 7px 8px;
  font-size: 15px;
}
.main {
  display: flex;
  flex-direction: row;
  gap: 22px;
  margin-top: 20px;
  width: 1500px;
  min-height: 600px;
  overflow: auto;
}
#editor, #renderer3d {
    flex: 1;
  display: none;
  width: 1200px;
  min-height: 700px;
  align-items: flex-start;
  justify-content: center;
  background: #161a23;
  overflow-x: auto;
  overflow-y: auto;
}
#editor.active, #renderer3d.active { display: flex; }
.layer-list {
  width: 280px;
  min-width: 200px;
  background: #20253a;
  border-radius: 14px;
  box-shadow: 0 2px 16px #0003;
  padding: 24px 16px;
  margin-right: 32px;
  height: 50vh;
  max-height: 980px;
  overflow-y: auto;
}
.layer-list h3 { margin-top: 0; }
.layer-item { display: flex; align-items: center; margin-bottom: 12px; background: #23263a; border-radius: 7px; padding: 7px 9px; cursor: grab;}
.layer-item img { width: 40px; height: 40px; object-fit: contain; margin-right: 10px; border-radius: 4px; border: 1px solid #2a2c45; background: #171928;}
.layer-controls { margin-left: auto; display: flex; gap: 4px;}
/* --- FORCE THE FLAT CANVAS TO 600x450 --- */
#canvas-flat {
  width: 600px !important;
  height: 450px !important;
  min-width: 600px !important;
  min-height: 450px !important;
  max-width: 100vw;
  max-height: 90vh;
  border: 2px solid #404360;
  background: #11131b;
  border-radius: 13px;
  box-shadow: 0 2px 28px #0007;
  position: relative;
  overflow: hidden; 
  margin: 0 auto;
  display: block;
}
#renderer3d {
    flex: 1;
  display: none;
  min-height: 700px;
  align-items: flex-start;
  justify-content: center;
  background: #161a23;
  overflow-x: auto;
  overflow-y: auto;
}
.plaque-preview { position: absolute; left: 50%; bottom: 16px; transform: translateX(-50%); background: #bfa96c; color: #222; padding: 6px 18px; border-radius: 5px; font-weight: bold; font-size: 17px; box-shadow: 0 2px 10px #0004; border: 1px solid #c7b589; max-width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
@media (max-width: 1100px) {
  .dashboard-toolbar, .toolbar-bottom { grid-template-columns: 1fr; gap: 18px; }
  #main { flex-direction: column; gap: 14px; }
  .layer-list { width: 99vw; min-width: 120px; margin-right: 0; }
  #canvas-flat { width: 98vw !important; height: 73vw !important; min-width: 0 !important; min-height: 0 !important;}
}
@media (max-width: 700px) {
  #canvas-flat { width: 99vw !important; height: 70vw !important; min-width: 0 !important; min-height: 0 !important; }
  .layer-list { padding: 13px 6px; }
}
  </style>
